import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { FormikProps, Formik, Form, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputSelectField } from "../../../../components/Shared/InputSelectField";
import { includes } from "lodash";
import { InputField } from "../../../../components/Shared/InputField";
import qs from "qs";

interface IFormProps {
    t?: any | undefined;
    moduleState: any;
    setQuery: any;
    dropdowns: any;
    visibility: any;
    toastify: any;
    onClose?: any;
}

type TInputForm = {
    belongsTo?: any,
    providers?: any,
    fromLocations?: any,
    toLocations?: any,
    brands?: any,
    dealers?: any,
    models?: any,
    // statuses?: any,
    // automaticStartNextJourney?: any,
    vin_numbers?: any,
    load_numbers?: any,
};

const DEFAULT_FORM_STATE = {
    belongsTo: [],
    providers: [],
    fromLocations: [],
    toLocations: [],
    brands: [],
    dealers: [],
    models: [],
    // statuses: ['produced'],
    // automaticStartNextJourney: [],
    vin_numbers: null,
    load_numbers: null,
};

// @ts-ignore
function OrderTransportRequestFilter(props: IFormProps) {
    const { t, visibility, dropdowns } = props;
    const formRef: any = useRef();
    const [initFormState, setInitFormState] = useState<any>(DEFAULT_FORM_STATE);
    const [panelState, setPanelState] = useState<boolean>(false);

    const onSubmit = async (payloads: any) => {
        props.setQuery({
            ...props.moduleState,
            filters: payloads
        });
    };

    const onReset = () => {
        const base: any = formRef.current;
        if ( base ) {
            base.resetForm();
            setInitFormState({
                ...DEFAULT_FORM_STATE
            })
        }

        props.setQuery({
            ...props.moduleState,
            // filters: { statuses: ['produced'] }
        });
    };

    const onClose = () => {
        setPanelState(false);

        if ( props.onClose ) {
            props.onClose();
        }
    };

    useEffect(() => {
        if ( visibility ) {
            setPanelState(visibility);
            setInitFormState({...DEFAULT_FORM_STATE, ...props.moduleState.filters ?? []});
        }
    }, [visibility]);

    const onChangeBrands = (e: any) => {
        if ( formRef.current && dropdowns.models && dropdowns.brands) {
            const values = formRef.current.values;
            const newModels: any = [];

            dropdowns.models.map(function (item: any) {
                if ( includes(values.brandModels, item.id) && includes(e.value, item.brand_id) ) {
                    newModels.push(item.id);
                }
            });

            formRef.current.setFieldValue('brandModels', newModels);
        }
    }

    return (
        <>
            <div>
                <Sidebar
                    header={
                        <div className="bg-body-tertiary card-header">
                            <h5 className={ "card-title mt-0" }>{ t('advance filters') }</h5>
                            <p>{ t("using filters you can archive better result.") }</p>
                        </div>
                    }
                    visible={ panelState } position="left" onHide={ onClose } blockScroll={ true }
                    style={ { width: '800px' } } closeOnEscape={ false }
                >
                    <div style={ {
                        height: '3px',
                        background: 'linear-gradient(90deg, var(--primary-color) 0%, rgba(33, 150, 243, 0) 50%)'
                    } }></div>
                    <Formik
                        innerRef={ formRef }
                        enableReinitialize={ true }
                        initialValues={ initFormState }
                        onSubmit={ onSubmit }
                    >
                        { (props: FormikProps<TInputForm>) => {
                            return (
                                <Form onSubmit={ props.handleSubmit }>
                                    <Row className={ "mt-4 md:mb-7 sm:mb-7" }>
                                        <Col sm={ 6 }>
                                            <Field component={ InputField }
                                                   name="vin_numbers"
                                                   label={ t("vin number") }
                                                   placeholder={ t("enter") + ' ' + t("vin number").toLowerCase() }
                                                   formText={ t("a series of vin number values, each separated by a space") }
                                                   autoFocus={true}
                                            />
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputField }
                                                   name="load_numbers"
                                                   label={ t("load number") }
                                                   placeholder={ t("enter") + ' ' + t("load number").toLowerCase() }
                                                   formText={ t("a series of load number values, each separated by a space") }
                                            />
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputSelectField }
                                                   options={ [
                                                       { id: 'nissan', label: 'Nissan' },
                                                       { id: 'renault', label: 'Renault' },
                                                       { id: 'system', label: 'System' },
                                                       { id: 'alp', label: 'Emil Frey' }
                                                   ] }
                                                   name="belongsTo"
                                                   placeholder={ t("select") + ' ' + t("source type") }
                                                   label={ t('source type') } showClear/>
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputSelectField }
                                                   options={ dropdowns?.providers || [] }
                                                   name="providers"
                                                   placeholder={ t("select") + ' ' + t("providers") }
                                                   label={ t('providers') } showClear />
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputSelectField }
                                                   options={ dropdowns?.clients }
                                                   name="clients"
                                                   placeholder={ t("select") + ' ' + t("clients") }
                                                   label={ t('clients') } showClear />
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputSelectField }
                                                   options={ dropdowns?.locations }
                                                   name="fromLocations"
                                                   placeholder={ t("select") + ' ' + t("from locations") }
                                                   label={ t('from locations') } showClear />
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputSelectField }
                                                   options={ dropdowns?.locations }
                                                   name="toLocations"
                                                   placeholder={ t("select") + ' ' + t("to locations") }
                                                   label={ t('to locations') } showClear />
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputSelectField }
                                                   options={ dropdowns?.brands }
                                                   name="brands"
                                                   placeholder={ t("select") + ' ' + t("brands") }
                                                   label={ t('brands') } showClear />
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputSelectField }
                                                   options={ dropdowns?.dealers }
                                                   name="dealers"
                                                   placeholder={ t("select") + ' ' + t("dealers") }
                                                   label={ t('dealers') } showClear />
                                        </Col>
                                        <Col sm={ 6 }>
                                            <Field component={ InputSelectField }
                                                   options={ dropdowns?.models }
                                                   name="models"
                                                   placeholder={ t("select") + ' ' + t("models") }
                                                   label={ t('models') } showClear />
                                        </Col>
                                        {/*<Col sm={ 6 }>*/}
                                        {/*    <Field component={ InputSelectField }*/}
                                        {/*           options={ dropdowns?.statuses }*/}
                                        {/*           name="statuses"*/}
                                        {/*           placeholder={ t("select") + ' ' + t("status") }*/}
                                        {/*           label={ t('statuses') } showClear />*/}
                                        {/*</Col>*/}
                                        {/*<Col sm={ 6 }>*/}
                                        {/*    <Field component={ InputSelectField }*/}
                                        {/*           options={ dropdowns?.automaticStartNextJourney }*/}
                                        {/*           name="automaticStartNextJourney"*/}
                                        {/*           label={ t('automatic start next journey') } showClear />*/}
                                        {/*</Col>*/}
                                    </Row>
                                    <div className="filter filter-card-footer"
                                         style={ { width: '785px' } }>
                                        <Button type={ "submit" } disabled={ props.isSubmitting }
                                                tooltip={ t("apply filter") }
                                                size={ "small" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-filter me-2" />
                                            { t("filter") }
                                        </Button>
                                        <Button type={ "button" } disabled={ props.isSubmitting }
                                                onClick={ onReset }
                                                tooltip={ t("to make all fields empty") } className={ "ms-2" }
                                                size={ "small" } severity={ "warning" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-refresh me-2" />
                                            { t("reset") }
                                        </Button>
                                        <Button type={ "button" } disabled={ props.isSubmitting }
                                                onClick={ onClose }
                                                tooltip={ t("operation cancel") } className={ "ms-2" }
                                                size={ "small" } severity={ "danger" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-arrow-left me-2" />
                                            { t("close") }
                                        </Button>
                                    </div>
                                </Form>
                            );
                        } }
                    </Formik>
                </Sidebar>
            </div>
        </>
    );
}

OrderTransportRequestFilter.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(OrderTransportRequestFilter);

